import axios from 'axios';

// 預設改為使用線上 API 網址，確保在 http://localhost:3000/login 也會打到遠端伺服器
// 如果需要改回本機後端，可在 .env 設定 REACT_APP_API_URL=http://localhost:5000/api
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.blueberry1048.com/api';

// Create axios instance
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
  timeout: 10000,
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors and fix date format
api.interceptors.response.use(
  (response) => {
    // 如果是获取记录列表的响应，检查并修复日期格式
    if (response.config?.url?.includes('/bus-records') && response.config?.method === 'get' && response.data) {
      // 处理数组格式的响应
      if (Array.isArray(response.data)) {
        response.data = response.data.map(record => {
          if (record.date) {
            // 如果日期是 ISO 格式（包含 T），提取日期部分
            if (typeof record.date === 'string' && record.date.includes('T')) {
              // 从 ISO 格式中提取日期部分，使用本地时区
              const dateObj = new Date(record.date);
              // 使用本地时区格式化日期，避免时区转换问题
              const year = dateObj.getFullYear();
              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
              const day = String(dateObj.getDate()).padStart(2, '0');
              record.date = `${year}-${month}-${day}`;
            }
          }
          return record;
        });
      } else if (response.data.data && Array.isArray(response.data.data)) {
        // 处理嵌套在 data 属性中的数组
        response.data.data = response.data.data.map(record => {
          if (record.date) {
            if (typeof record.date === 'string' && record.date.includes('T')) {
              const dateObj = new Date(record.date);
              const year = dateObj.getFullYear();
              const month = String(dateObj.getMonth() + 1).padStart(2, '0');
              const day = String(dateObj.getDate()).padStart(2, '0');
              record.date = `${year}-${month}-${day}`;
            }
          }
          return record;
        });
      }
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  verify: () => api.get('/auth/verify'),
};

// Bus Records API
export const busRecordsAPI = {
  getAll: () => api.get('/bus-records'),
  create: (record) => api.post('/bus-records', record),
  update: (id, record) => api.put(`/bus-records/${id}`, record),
  delete: (id) => api.delete(`/bus-records/${id}`),
};


// Statistics API
export const statsAPI = {
  getBusCompanies: () => api.get('/stats/bus-companies'),
  getBusTypes: () => api.get('/stats/bus-types'),
  getRoutes: () => api.get('/stats/routes'),
  getMonthly: () => api.get('/stats/monthly'),
  getOverview: () => api.get('/stats/overview'),
};

export default api;
